module.exports = __webpack_public_path__ + "img/jj1.a50a1fa9.png";